import { render } from "./page-agentsearch.vue?vue&type=template&id=1c064858"
import script from "./page-agentsearch.js?vue&type=script&lang=js"
export * from "./page-agentsearch.js?vue&type=script&lang=js"

import "./page-agentsearch.vue?vue&type=style&index=0&id=1c064858&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__